import { StageCandidateActionType } from 'enums/stageAction';
import { CompanyReasonableAdjustmentsOptionFragment } from 'generated/graphql';
import {
  adjustmentsResponsesType,
  getAiInterviewTimeAmountAdded,
  getTimeAmountAdded,
  steps,
  TAdjustmentsFlowRoutes,
} from './AccessibilityAdjustments.helpers';
import AccessibilityDetails from './AccessibilityDetails/AccessibilityDetails';
import AccessibilityIntro from './AccessibilityIntro/AccessibilityIntro';
import AccessibilityNeedsList from './AccessibilityNeedsList/AccessibilityNeedsList';
import AccessibilitySummary from './AccessibilitySummary/AccessibilitySummary';

const AccessibilityAdjustmentStep = ({
  step,
  responses,
  handleProgress,
  handleSubmitResponses,
  tests,
  loading,
  completedStep,
  handleResponses,
  flowRoutes,
  companyName,
  companyReasonableAdjustmentsOption,
  usesBehaviouralLabel,
  extraTimeOverrides,
  shouldContactUs,
  isLiveChatEnabled,
}: {
  step?: string;
  responses: adjustmentsResponsesType;
  handleProgress: (step: steps) => void;
  handleResponses: (values: adjustmentsResponsesType, step: steps) => void;
  handleSubmitResponses: (redirectUrl: string, step?: steps) => void;
  tests: StageCandidateActionType[];
  loading: boolean;
  completedStep: steps;
  flowRoutes: TAdjustmentsFlowRoutes;
  companyName: string;
  companyReasonableAdjustmentsOption?: CompanyReasonableAdjustmentsOptionFragment;
  usesBehaviouralLabel?: boolean;
  extraTimeOverrides?: Partial<Record<StageCandidateActionType, string>>;
  shouldContactUs: boolean;
  /** The company's "Display live chat to users" setting (see the steps). */
  isLiveChatEnabled: boolean;
}) => {
  if (step === 'options') {
    return (
      <AccessibilityNeedsList
        flowRoutes={flowRoutes}
        completedStep={completedStep}
        tests={tests}
        onSubmit={handleResponses}
        isLiveChatEnabled={isLiveChatEnabled}
      />
    );
  }
  if (step === 'summary') {
    return (
      <AccessibilitySummary
        flowRoutes={flowRoutes}
        responses={responses}
        tests={tests}
        completedStep={completedStep}
        onSubmit={handleSubmitResponses}
        loading={loading}
        isLiveChatEnabled={isLiveChatEnabled}
      />
    );
  }
  if (step === 'details') {
    return (
      <AccessibilityDetails
        tests={tests}
        extraTime={getTimeAmountAdded(responses)}
        aiInterviewExtraTime={getAiInterviewTimeAmountAdded(responses)}
        shouldContactUs={shouldContactUs}
        handleProgress={handleProgress}
        flowRoutes={flowRoutes}
        usesBehaviouralLabel={usesBehaviouralLabel}
        extraTimeOverrides={extraTimeOverrides}
        isLiveChatEnabled={isLiveChatEnabled}
      />
    );
  }
  // Default to intro page
  return (
    <AccessibilityIntro
      companyName={companyName}
      flowRoutes={flowRoutes}
      onContinue={handleProgress}
      onCancelFlow={handleSubmitResponses}
      loading={loading}
      companyReasonableAdjustmentsOption={companyReasonableAdjustmentsOption}
    />
  );
};

export default AccessibilityAdjustmentStep;
